// src/components/AboutSection.jsx
import React from "react";

export default function AboutSection() {
  return (
    <section className=" py-16 sm:py-20">
      <div className="max-w-5xl mx-auto px-4 text-center">
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
          Biz haqimizda
        </h2>

        <p className="mt-5 text-sm sm:text-base md:text-lg leading-relaxed text-gray-600">
          LiveQuiz — bu o‘qituvchilar, ta’lim markazlari va o‘quvchilar uchun
          yaratilgan zamonaviy onlayn platforma. Ushbu platforma PDF hujjatlar va matn fayllaridan tezkor va sifatli
          testlar tuzishga yordam beruvchi sun’iy intellekt asosidagi qulay
          xizmatdir. LiveQuiz orqali nafaqat testlar avtomatik yaratiladi,
          balki o‘quvchilar ularni real vaqtda yechib, o‘qituvchilar esa
          natijalarni jonli kuzatib borishi, guruh bo‘yicha tahlil qilishi va
          darhol fikr-mulohaza berishi mumkin. Platforma o‘zbek, rus va ingliz
          tillarini qo‘llab-quvvatlaydi.
        </p>
      </div>
    </section>
  );
}
